<template>
	<dt
		:class="dtClass"
		class="text-sm flex justify-between items-start gap-1 not-last-of-type:border-b py-2"
	>
		<span>{{ label }}</span>
		<div class="pr-4 flex gap-1">
			<slot name="actions" />
		</div>
	</dt>
	<dd :class="ddClass" class="not-last-of-type:border-b py-2">
		<slot />
	</dd>
</template>

<script setup lang="ts">
defineProps<{
	label: string;
	ddClass?: string;
	dtClass?: string;
}>();
</script>
